// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-1mMDx";
var _3 = "trigger-xrcTA";
var _4 = "triggerContent-18G4z";
var _5 = "enabled-2nDL3";
var _6 = "triggerButton-181yZ";
var _7 = "rootOpened-1EGcP";
var _8 = "price__item-iUuvF";
var _9 = "price__label-26Wn-";
var _a = "price__item_highlighted-2WO5T";
export { _1 as "__esModule", _2 as "root", _3 as "trigger", _4 as "triggerContent", _5 as "enabled", _6 as "triggerButton", _7 as "rootOpened", _8 as "price__item", _9 as "price__label", _a as "price__item_highlighted" }
export default { "__esModule": _1, "root": _2, "trigger": _3, "triggerContent": _4, "enabled": _5, "triggerButton": _6, "rootOpened": _7, "price__item": _8, "price__label": _9, "price__item_highlighted": _a }
